<script setup lang="ts">
withDefaults(defineProps<{
  size?: 'md' | 'sm'
}>(), {
  size: 'md',
})
</script>

<template>
  <svg
    class="shrink-0 dark:hidden"
    :class="size === 'sm' ? 'size-4' : 'size-5'"
    viewBox="0 0 100 100"
    fill="none"
  >
    <rect width="100" height="100" rx="12" fill="white" />
  </svg>
  <svg
    class="hidden shrink-0 dark:block"
    :class="size === 'sm' ? 'size-4' : 'size-5'"
    viewBox="0 0 100 100"
    fill="none"
  >
    <rect width="100" height="100" rx="12" fill="#0052FF" />
  </svg>
</template>
